import httpClient from "./httpClient";
import qs from "qs";
import type { ApiResponse, NotificationPayload } from "../types/api";

export default class NotificationApi {
  static getAll(): Promise<ApiResponse> {
    return httpClient.get(API_URL + "/notification").then((response) => response.data);
  }

  static update(data: NotificationPayload): Promise<ApiResponse> {
    return httpClient
      .post(API_URL + "/notification/" + data.id, qs.stringify(data))
      .then((response) => response.data);
  }

  static updateAll(): Promise<ApiResponse> {
    return httpClient
      .post(API_URL + "/notification/mark_all_as_read", qs.stringify({ read: 1 }))
      .then((response) => response.data);
  }

  static markManyAsRead(ids: Array<number | string>): Promise<ApiResponse> {
    return httpClient
      .post(API_URL + "/notification/mark_many_as_read", qs.stringify({ ids }))
      .then((response) => response.data);
  }

  static delete(id: number | string): Promise<ApiResponse> {
    return httpClient
      .post(API_URL + "/notification/delete_one/" + id, qs.stringify({ id }))
      .then((response) => response.data);
  }

  static deleteMany(ids: Array<number | string>): Promise<ApiResponse> {
    return httpClient
      .post(API_URL + "/notification/delete_many", qs.stringify({ ids }))
      .then((response) => response.data);
  }
}
